import { Box } from '@chakra-ui/react';

const Eyebrow = ({ children, ...rest }) => (
  <Box textTransform="uppercase" fontWeight={700} {...rest}>
    {children}
  </Box>
);

export default Eyebrow;
